import { render, staticRenderFns } from "./T1GTabsContent.vue?vue&type=template&id=21adee51&scoped=true&"
import script from "./T1GTabsContent.vue?vue&type=script&lang=js&"
export * from "./T1GTabsContent.vue?vue&type=script&lang=js&"
import style0 from "./T1GTabsContent.vue?vue&type=style&index=0&id=21adee51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21adee51",
  null
  
)

export default component.exports